import { H3 } from "../Typography/Typography";
import { PrimaryButtonLargeV2 } from "../Buttons/Buttons";
import { CenterContainer } from "../../layout/publicPageLayout";
import { useTranslation } from "react-i18next";
import { useHistory } from "react-router-dom";

interface IErrorPlaceholder {
  message: string;
  showBackButton?: boolean;
  backUrl?: string;
}

/**
 * Display a placeholder error page with custom message if a request fails
 * @param message: string
 */
export function ErrorPlaceholder({
  message,
  showBackButton = false,
  backUrl,
}: IErrorPlaceholder) {
  const history = useHistory();
  const handleClick = () => {
    window.location.reload();
  };

  const handleClickBack = () => {
    if (backUrl) {
      history.replace(backUrl);
    } else {
      history.goBack();
    }
  };

  const { t } = useTranslation();

  return (
    <>
      <CenterContainer>
        <H3>{message}</H3>
        {showBackButton ? (
          <PrimaryButtonLargeV2 onClick={handleClickBack}>
            {t("Back")}
          </PrimaryButtonLargeV2>
        ) : (
          <PrimaryButtonLargeV2 onClick={handleClick}>
            {t("Reload Page")}
          </PrimaryButtonLargeV2>
        )}
      </CenterContainer>
    </>
  );
}
